import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { RoutePaths } from '../models/route-paths.model';
import { UserScopesService } from '../services/user-scopes.service';

export const hasOrganizationsGuard: CanActivateFn = () => {
  const router = inject(Router);

  return inject(UserScopesService)
    .getOrganizationScopeParameterValues()
    .pipe(
      map((organizations) => (organizations.length > 0 ? true : router.parseUrl(RoutePaths.Forbidden))),
      catchError(() => of(router.parseUrl(RoutePaths.Forbidden)))
    );
};
